import * as consts from './ListingsConsts';

const initialState = {
    listingsList: [],
    listingsCount: 0,
    listingPerPage: 4,
    getListingsFulfilled: false,
    getListingsError: ''
};

const listings = (state = initialState, action) => {
    switch (action.type) {
        case consts.GET_LISTINGS_PENDING:
            return {
                ...state,
                getListingsFulfilled: false
            }
        case consts.GET_LISTINGS_REJECTED:
            return {
                ...state,
                getListingsFulfilled: true
            }
        case consts.GET_LISTINGS_FULFILLED:
            return {
                ...state,
                getListingsFulfilled: true,
                listingsList: action.payload.listings || [],
                listingsCount: action.payload.count || 0,
            }
        case consts.LISTINGS_PAGINATION_FULFILLED:
            return {
                ...state,
                getListingsFulfilled: true,
                listingsList: action.payload.listings,
            }
        default:
            return state
    }
}

export default listings;
